var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.5C15 11.6426 11.6421 15 7.5 15C3.35791 15 0 11.6426 0 7.5C0 3.35742 3.35791 0 7.5 0C11.6421 0 15 3.35742 15 7.5ZM10.8038 5.35938C10.9938 5.16992 10.9935 4.86133 10.8035 4.67188L10.402 4.27148C10.2119 4.08008 9.90393 4.08008 9.71411 4.26953L7.57324 6.41211L7.52991 6.45508L7.48462 6.41016L5.34375 4.26953C5.15393 4.08008 4.84595 4.08008 4.65588 4.26953L4.25439 4.67188C4.06433 4.86133 4.06409 5.16992 4.25403 5.35938L6.3949 7.5L6.43982 7.54492L4.34375 9.64062C4.15393 9.83008 4.15405 10.1387 4.34412 10.3281L4.74561 10.7305C4.93567 10.9199 5.24365 10.9199 5.43347 10.7305L7.52991 8.63477L9.62439 10.7305C9.81421 10.9199 10.1222 10.9199 10.3123 10.7285L10.7137 10.3281C10.9038 10.1387 10.9039 9.83008 10.7141 9.64062L8.61816 7.54492L8.66296 7.5L10.8038 5.35938Z",
    fill: "#A0A0A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.b9b918c27e835496a57c89003d8f2185.svg";
export { ForwardRef as ReactComponent };